import React, { Component } from 'react';
import { StaticQuery, Link, graphql } from 'gatsby';
import { Trans, withI18n } from '@lingui/react';
import { prefix } from '../i18n-config';

// import Img from 'gatsby-image';
import Slider from "react-slick";
import Button from './Button';

// images
import LogoPrecogStudio from '../../static/branding/precog_wordmark.png';
import LogoPrecogStudioWhite from '../../static/branding/precog-white-wordmark.png';
import LogoPrecogStudioBlack from '../../static/branding/precog-black-wordmark.png';


class NavPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      liHover: '',
      hasScrolled: true,
      scrollY: 0,
      isOpen: false,
      headerHeight: 80
    };

    this.Pos = '';
    this.scrollContainer = null;
    this.handleClick = this.handleClick.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    const { hasScrolled, liHover } = this.state;
    this.scrollContainer = document.querySelector('.main-wrapper');
    window.addEventListener('scroll', this.handleScroll);
    setInterval(() => {
      if (hasScrolled) {
        this.fixNavOnScroll();
      }
    }, 150);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleToggleClick(e) {
    const { isOpen } = this.state;
    this.setState({isOpen : !isOpen});
  }

  handleClick(e) {
    this.handleEnter(e);

    const target = e.target.dataset.target;
    const targetElem = document.querySelector(`#${target}`);

    if (targetElem) {
      e.preventDefault();

      targetElem.scrollIntoView({
          behavior: 'smooth',
      });
    }
  }

  handleEnter(e) {
    const target = e.target.dataset.target;

    this.setState({
      liHover: target,
    });
  }

  handleLeave() {
    this.setState({
      liHover: '',
    });
  }

  handleScroll() {
    const scrollTop = window.scrollY;
    const height = Math.min(105, 80 + scrollTop);

    this.setState({
      hasScrolled: true,
      headerHeight: height,
      headerBg: height === 105
    });
  }

  fixNavOnScroll() {
    const { scrollY, isOpen } = this.state;
    const currentPos = window.scrollY;

    if (Math.abs(scrollY - currentPos) <= 20) {
      return;
    }
    // console.log(currentPos);
    
    // if (scrollY > 0 && currentPos > scrollY) {
    //   // Scroll Down
    //   this.setState({ navUp: true });
    // } else {
    //   // Scroll Up
    //   this.setState({ navUp: false });
    // }
    if (currentPos > 100) {
      this.setState({ headerBg: true });
    } else {
      this.setState({ headerBg: false });
    }
    this.setState({
      hasScrolled: false,
      scrollY: currentPos,
    });
  }

  render() {
    const {
      lang, location, pathName
    } = this.props;
    const { navUp, liHover, headerBg, isOpen } = this.state;
    const langPrefix = prefix(lang);

    return (
      <header
        className={`main-header ${
          navUp ? 'main-header--hidden' : 'main-header--visible'
        } ${headerBg ? 'main-header--bg' : ''}`}
        style={{height: this.state.headerHeight+'px'}}
      >
        <div className="container">
          <Link
            to={`${langPrefix}/`}
            className="main-header__logo-wrapper"
            onClick={(e) => {
              this.handleClick(e);
            }}
          >
            <img src={headerBg ? LogoPrecogStudioWhite : LogoPrecogStudioBlack} alt="Precog Studio" className="main-header__logo" />
          </Link>

          <div className={`main-menu ${!liHover && pathName === '/' ? 'no-active-item' : ''}`}>
            <button
              type="button"
              className={`main-menu__toggle ${isOpen ? 'toggled' : ''}`}
              onClick={() => {
                this.handleToggleClick();
              }}
            >
              <ul className="lines">
                <li className="line"></li>
                <li className="line"></li>
              </ul>
            </button>
            <div className={`main-menu__list ${isOpen ? 'toggled' : ''}`}>
              <div
                className={`main-menu__list__item ${liHover === 'who-we-are' ? 'active' : ''} ${
                  pathName.includes('who-we-are') ? 'active' : ''
                }`}
                onMouseEnter={e => this.handleEnter(e)}
                onMouseLeave={e => this.handleLeave(e)}
              >
                <Link
                  to={`${langPrefix}/#who-we-are`}
                  data-target="who-we-are"
                  onClick={(e) => {
                    this.handleClick(e);
                  }}
                >
                  Who we are
                </Link>
              </div>
              <div
                className={`main-menu__list__item ${liHover === 'subscribe' ? 'active' : ''} ${
                  pathName.includes('subscribe') ? 'active' : ''
                }`}
                onMouseEnter={e => this.handleEnter(e)}
                onMouseLeave={e => this.handleLeave(e)}
              >
                <Link
                  to={`${langPrefix}/#subscribe`}
                  data-target="subscribe"
                  onClick={(e) => {
                    this.handleClick(e);
                  }}
                >
                  Subscribe
                </Link>
              </div>
              <div 
                className={`main-menu__list__item  ${liHover === 'contact-us' ? 'active' : ''} ${
                  pathName.includes('contact-us') ? 'active' : ''
                }`}
              >
                <Link
                  to={`/#contact-us`}
                  onMouseEnter={e => this.handleEnter(e)}
                  onMouseLeave={e => this.handleLeave(e)}
                  data-target="contact-us"
                  onClick={(e) => {
                    this.handleClick(e);
                  }}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </header>
    );
  }
}
/*
            <div
              className={`main-menu__list__item ${liHover === 'our-services' ? 'active' : ''} ${
                pathName.includes('our-services') ? 'active' : ''
              }`}
              onMouseEnter={e => this.handleEnter(e)}
              onMouseLeave={e => this.handleLeave(e)}
            >
              <Link
                to={`${langPrefix}/#our-services`}
                data-target="our-services"
                onClick={(e) => {
                  this.handleClick(e);
                }}
              >
                Our Services
              </Link>
            </div>
*/          
export default withI18n()(NavPanel);
